import { render, staticRenderFns } from "./d_PhysicalExamination.vue?vue&type=template&id=3b700ee6&scoped=true&"
import script from "./d_PhysicalExamination.vue?vue&type=script&lang=js&"
export * from "./d_PhysicalExamination.vue?vue&type=script&lang=js&"
import style0 from "./d_PhysicalExamination.vue?vue&type=style&index=0&id=3b700ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b700ee6",
  null
  
)

export default component.exports